export default{
    profile: {
        'aggression': 'beepiz-aggression',
        'allow_monitoring_inhibition': 'zmdi zmdi-pause-circle',
        'auto_offhook': 'zmdi zmdi-phone-msg',
        'battery': 'zmdi zmdi-battery-alert',
        'bt': 'zmdi zmdi-bluetooth',
        'dedicated_device': 'zmdi zmdi-smartphone-lock',
        'fall': 'beepiz-fall',
        'gps': 'zmdi zmdi-gps-dot',
        'immo': 'beepiz-immo',
        'lostcom': 'zmdi zmdi-cloud-off',
        'mode': 'zmdi zmdi-eye',
        'nfc': 'zmdi zmdi-nfc',
        'optID': 'zmdi zmdi-account-circle',
        'phone': 'zmdi zmdi-phone-forwarded',
        'sos': 'beepiz-sos',
        'verticality': 'beepiz-verticality',
        'wifi': 'zmdi zmdi-wifi',
        'phonebook_id': 'fa fa-address-book',
        'idcard': 'fa fa-id-card',
        'telesurveilleur': 'fa fa-binoculars',
        'video': 'zmdi zmdi-videocam',
        'ppe_list_id': 'fa fa-shield',
        'road_mode': 'fa fa-road',
        'desk_mode': 'beepiz-desk'
    },

    plans: {
        '1': '',
        '2': 'fa fa-globe',
        '3': 'beepiz-plan-group',
        '4': 'fa fa-building',
        '5': 'beepiz-stairs',
        '6': 'beepiz-folder',
        '7': 'fa fa-map',
    },

    actionpoints: {
        '1': 'fa fa-wifi',
        '2': 'fa fa-bluetooth',
        '3': 'zmdi zmdi-nfc',
        '4': 'fa fa-qrcode',
        '5': 'fa fa-bluetooth',
        '6': 'beepiz-annotate',
        '7': 'beepiz-folder',
    },

    actionpointsSelect: {
        'wifi': '&#xf1eb;',
        'beacon': '&#xf293;',
        'nfc': '&#xf3e1',
        'qrcode': '&#xf029;'
    },
    filters: {
        'wifi': 'fa fa-wifi',
        'beacon': 'fa fa-bluetooth',
        'nfc': 'zmdi zmdi-nfc',
        'qrcode': 'fa fa-qrcode',
    },

    remoteMonitoringProviders: {
        '1': 'beepiz-logo-app',
        'Providers': 'fa fa-binoculars',
        'Protocols': 'fa fa-terminal',
    },

    remoteMonitoringLogsTypes: {
        '1': 'fa fa-check',     //Validation
        '2': 'fa fa-plus',    //Actions de création
        '3': 'fa fa-pencil',    //Actions de modification
        '4': 'fa fa-bullhorn'   //Envoi d'alertes
    }

}
